module.exports = __webpack_public_path__ + "static/media/icon_mission_date.2cf8854e.svg";